import { action,observable,computed,toJS } from 'mobx'
import T from 'i18n-react'
import route from './fetchconfig.json'

export default class NewExampleFormStore {

  @observable id
  @observable title
  @observable description
  @observable link
  @observable image
  @observable competenceSteps
  @observable lessons
  @observable type
  @observable contact
  @observable previewImages

  MINUTE_STEPS = 5
  ONE_LESSON = 45
  minLessons = 1 * this.ONE_LESSON
  maxLessons = 15 * this.ONE_LESSON

  defaultType = { name:'test', id:"" }

  constructor (example) {
    this.clear()
  }

  injectExample (example) {
    const { id,title,description,link,image,competenceSteps,lessons,type,contact } = example

    this.id = id
    this.title = title ? title : ""
    this.description = description ? description : ""
    this.link = link ? link : ""
    this.image = image ? image : ""
    this.competenceSteps = competenceSteps ? competenceSteps : null
    this.lessons = lessons ? lessons : [0,0]
    this.type = type ? type : this.defaultType
    this.contact = contact ? contact : ''
    this.previewImages = this.previewImages ? this.previewImages : []
  }

  @action clear () {
    this.title = ""
    this.description = ""
    this.link = ""
    this.image = ""
    this.competenceSteps = null
    this.lessons = [0,0]
    this.type = this.defaultType
    this.contact = ""
    this.previewImages = this.previewImages ? this.previewImages : []
  }

  getChipData (lehrplan) {
   let temp = []
   if (!lehrplan) {
     return temp
   }
   let arr = this.competenceSteps
   if (!arr|| arr.length === 0) return temp

   for (let i = 0; i < lehrplan.length; i++) {
     let kompetenz = lehrplan[i]
     for (let j = 0; j < kompetenz.kompetenzstufen.length; j++) {
       let kompetenzStufe = kompetenz.kompetenzstufen[j]
       for (let k = 0; k < arr.length; k++) {
         let filter = arr[k]
         if (kompetenzStufe.id === filter) {
           temp.push(kompetenzStufe)
         }
       }
     }
   }

   return temp
  }

  @action.bound toggleCompetenceStep (id) {
    if (!this.isActiveCompetenceStep(id)) {
     this.addCompetenceStep(id)
    } else {
     this.removeCompetenceStep(id)
   }
  }

  isActiveCompetenceStep (id) {
    for (let i = 0; i < this.competenceSteps.length; i++) {
      if (this.competenceSteps[i] === id) {
        return true
      }
    }
    return false
  }

  @action addCompetenceStep (id) {
    this.competenceSteps.push(id)
  }

  @action removeCompetenceStep (id) {
    this.competenceSteps = this.competenceSteps.filter( (item) => {
     if (item !== id) {
       return item
     }
    })
  }

  @action.bound setTitle (title) {
    this.title = title
  }

  @action.bound setDescription (description) {
    this.description = description
  }

  @action.bound setContact (contact) {
    this.contact = contact
  }

  @action.bound setLink (link) {
    this.link = link
  }

  @action.bound addPreviewImage (url) {
    url = this.checkForGoogleDriveImage(url)
    this.previewImages.push(url)
    this.image = url
  }

  @action.bound setImage (url) {
    this.image = url
  }

  checkForGoogleDriveImage (url) {
   const match = url.match(/\/d\/(.{25,})\//)
   if (match && match[1]) {
    return 'https://lh3.googleusercontent.com/d/'+match[1]
   }
   return url
  }

  @action.bound setType (type) {
   this.type = type
  }

  @action.bound setLessonsFrom (fromInMinutes) {
    this.lessons[0] = fromInMinutes
    if (!(this.lessons[1] > fromInMinutes)) {
     this.lessons[1] = fromInMinutes
    }
  }

  @action.bound setLessonsTo (toInMinutes) {
    // can't be smaller than lessonsFrom
    if (toInMinutes < this.lessons[0]) {
      this.lessons[0] = toInMinutes
    }
    this.lessons[1] = toInMinutes
  }

  @computed get lessonsFrom () {
    return this.lessons && this.lessons.length > 0 ? this.lessons[0] : 3 * this.ONE_LESSON
  }

  @computed get lessonsTo () {
    return this.lessons && this.lessons.length > 1 ? this.lessons[1] : this.lessonsFrom
  }

  @computed get lessonsToInLessons () {
    const to = parseInt(this.lessons[1] / this.ONE_LESSON)
    return to ? to : 0
  }

  @computed get lessonsFromInLessons () {
    const from = parseInt(this.lessons[0] / this.ONE_LESSON)
    return from ? from : 0
  }

  @computed get minutesFromAsRest () {
    const fromMinutes = this.lessons[0] % this.ONE_LESSON
    return fromMinutes ? fromMinutes : 0
  }

  @computed get minutesToAsRest () {
    const toMinutes = this.lessons[1] % this.ONE_LESSON
    return toMinutes ? toMinutes : 0
  }

  @computed get hasAToTime () {
    return this.lessons[1] > this.lessons[0]
  }

  @action.bound setCompetenceSteps (competenceSteps) {
    this.competenceSteps = competenceSteps
  }

  getLessons () {
    return toJS(this.lessons)
  }

  @action.bound generateImage (url) {
    fetch(route.endpoint + '/api/image?url='+url, {
       method: 'GET',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
       },
     })
     .then((res) => res.json())
     .then((data) => {
       this.setImage(data)
     })
     .catch((error) => {
       console.error(error);
     })
  }

  prepareLessonPayload () {
    if (this.lessons) {
      if (this.lessons[0] && this.lessons[1]) {
        // if both are the same, only calculate the from value
        if (this.lessons[0] === this.lessons[1]) {
          this.lessons[1] = null
        }
      }
    } else this.lessons = [0,0]
  }

  validatePayload = (payload) => {
    let isValid = true

    if (!payload.title || payload.title.trim() == "") {
      isValid = false
    }
    else if (!payload.type || !payload.type.id || (payload.type && payload.type.id && payload.type.id === "")) {
      isValid = false
    }
    else if (!payload.description || payload.description.trim() == "") {
      isValid = false
    }
    else if (!payload.link || payload.link.trim() == "") {
      isValid = false
    }

    return isValid
  }

  getPayload (validate) {
   this.prepareLessonPayload()
   const payload = {
    id:this.id,
    title:this.title,
    description:this.description,
    link:this.link,
    image:this.image,
    competenceSteps:this.competenceSteps,
    lessons:this.lessons,
    type:this.type,
    contact:this.contact
   }

   if (validate) {
    const isValid = this.validatePayload(payload)
    if (isValid) {
      return payload
    } else return null
   }

   return payload
  }

  isValidURL (url) {
    return url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z‌​]{2,6}\b([-a-zA-Z0-9‌​@:%_\+.~#?&=]*)/)
  }

}



// WEBPACK FOOTER //
// ./src/stores/newexampleform.js